import type {ICommentThreadData} from "@buildwithflux/models";

import type {DocumentSelector, DocumentStoreState, ParameterizedSelector} from "../types";

/**
 * Base selectors for comment threads - direct state reads
 * These selectors perform simple property access without complex computation
 */

/** Gets a comment thread by UID */
export const byUid: ParameterizedSelector<string, ICommentThreadData | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid];
};

/** Gets the UID of a comment thread */
export const uidByUid: ParameterizedSelector<string, string | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid]?.uid;
};

/** Gets the reference number of a comment thread */
export const referenceByUid: ParameterizedSelector<string, number | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid]?.reference;
};

/** Gets the owner UID of a comment thread */
export const ownerUidByUid: ParameterizedSelector<string, string | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid]?.owner_uid;
};

/** Gets the title of a comment thread */
export const titleByUid: ParameterizedSelector<string, string | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid]?.title;
};

/** Gets the comment count of a comment thread */
export const commentCountByUid: ParameterizedSelector<string, number | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid]?.comment_count;
};

/** Gets the anchor of a comment thread */
export const anchorByUid: ParameterizedSelector<string, ICommentThreadData["anchor"] | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid]?.anchor;
};

/** Gets the resolved status of a comment thread */
export const resolvedByUid: ParameterizedSelector<string, boolean | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid]?.resolved;
};

/** Gets the pinned status of a comment thread */
export const pinnedByUid: ParameterizedSelector<string, boolean | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.comment_threads?.[uid]?.pinned;
};
